export default __webpack_public_path__ + "static/media/biofuel-long-pellets-icon.4b736559.svg";